import React from 'react'
import { Auth0Provider, AppState } from '@auth0/auth0-react'
import { AUTH0 } from '../constants'
import { useHistory } from 'react-router-dom'
export interface Auth0ProviderWithHistoryProps {
  children: React.ReactChild
}

export default function Auth0ProviderWithHistory({
  children,
}: Auth0ProviderWithHistoryProps) {
  const history = useHistory()

  const onRedirectCallback = async (appState: AppState) => {
    if (appState.returnTo) {
      history.replace(`/?fwdTo=${encodeURIComponent(appState.returnTo)}`)
    }
  }

  return (
    <Auth0Provider
      domain={AUTH0.DOMAIN as string}
      clientId={AUTH0.CLIENT_ID as string}
      useRefreshTokens={true}
      cacheLocation={'localstorage'}
      redirectUri={`${window.location.origin}/`}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  )
}
